import { IUnternehmen } from './company-http.model';
import { RegistrationStatus } from './registration.model';
import { Address } from '@mwe/models';
import { transformAdresseToAddress } from './address.model';

export type KundenberaterUnternehmenSearchDto = {
  id: string;
  firstName: string;
  lastName: string;
};

export interface ICompany {
  name: string;
  gpNr: string;
  email: string;
  uid: string;
  hausverwaltung: boolean;
  mitarbeiterAnzahl?: string;
  branche?: string;
  address?: Address;
  status: RegistrationStatus;
  lastInvitation?: Date;
  kundenberater?: KundenberaterUnternehmenSearchDto;
}

export class Company implements ICompany {
  name: string;
  gpNr: string;
  email: string;
  uid: string;
  adminUserKeycloakId?: string;
  hausverwaltung: boolean;
  mitarbeiterAnzahl?: string;
  branche?: string;
  address?: Address;
  status: RegistrationStatus;
  accountId?: string;
  adminUserEmail?: string;
  lastInvitation?: Date;
  kundenberater?: KundenberaterUnternehmenSearchDto;

  constructor(unternehmen: IUnternehmen, address: Address) {
    this.name = unternehmen.name;
    this.gpNr = unternehmen.gpNr;
    this.email = unternehmen.email;
    this.uid = unternehmen.uid;
    this.adminUserKeycloakId = unternehmen.adminUserKeycloakId;
    this.hausverwaltung = unternehmen.hausverwaltung;
    this.mitarbeiterAnzahl = unternehmen.mitarbeiterAnzahl;
    this.branche = unternehmen.branche;
    this.address = address;
    this.status = unternehmen.status;
    this.lastInvitation = new Date(unternehmen.lastInvitation);
    this.accountId = unternehmen.accountId;
    this.adminUserEmail = unternehmen.adminUserEmail;
    this.kundenberater = unternehmen.kundenberater;
  }
}

export function transformToCompanies(response: IUnternehmen[]): Company[] {
  return response.map((unternehmenRaw: IUnternehmen) => {
    const address = transformAdresseToAddress(unternehmenRaw.adresse);
    return new Company(unternehmenRaw, address);
  });
}
